// Monkey-patch JavaScript context to contain all EcmaScript 5, 6 methods
// that can be faithfully emulated with a legacy JavaScript engine, e.g. IE
import ReactOnRails from 'react-on-rails';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faClock,
  faCaretDown,
  faTrash,
  faExclamationTriangle,
  faTimes,
  faMapMarker,
  faPhone,
  faCalendar,
} from '@fortawesome/free-solid-svg-icons';
import { WidgetXcomponent } from '../../../sdk/js/src/btaWidgetLoader/zoid';

import ActivityWidgetContainer from '../widgets/container/ActivityLoadable';
import AppointmentWidgetContainer from '../widgets/container/AppointmentLoadable';
import UpcomingEventWidgetContainer from '../widgets/container/UpcomingEventLoadable';
import ReservationWidgetContainer from '../widgets/container/ReservationLoadable';
import CourseWidgetContainer from '../widgets/container/CourseLoadable';
import RentalWidgetContainer from '../widgets/container/RentalLoadable';
import CalendarWidgetContainer from '../widgets/container/CalendarLoadable';
import ClassWidgetContainer from '../widgets/container/ClassLoadable';

library.add(faClock, faCaretDown, faExclamationTriangle, faTrash, faTimes, faMapMarker, faPhone, faCalendar);

__webpack_public_path__ = `${process.env.CLOUDFRONT_ENDPOINT || '//legros-parker-and-harris6290.bookthatapp.local:3002'}/packs/`;

ReactOnRails.register({
  ActivityWidgetContainer,
  AppointmentWidgetContainer,
  UpcomingEventWidgetContainer,
  ReservationWidgetContainer,
  CourseWidgetContainer,
  RentalWidgetContainer,
  CalendarWidgetContainer,
  ClassWidgetContainer
});
